export default __webpack_public_path__ + "static/media/music group button.3a314853.svg";